import b from "@emotion/styled/base";
const o = /* @__PURE__ */ b("thead", process.env.NODE_ENV === "production" ? {
  target: "e1l8zknx0"
} : {
  target: "e1l8zknx0",
  label: "StyledHeader"
})("padding:8px 24px;background-color:", ({
  theme: c
}) => c.colors.secondary.alpha, ";border-top:1px solid ", ({
  theme: c
}) => c.colors.default.alpha, ";border-bottom:1px solid ", ({
  theme: c
}) => c.colors.default.alpha, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3J1bm5lci93b3JrL3BhcnRvby11aS9wYXJ0b28tdWkvcGFja2FnZXMvdWkvc3JjL2NvbXBvbmVudHMvVGFibGUvc3ViQ29tcG9uZW50cy9IZWFkZXIvSGVhZGVyLnN0eWxlZC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFMkMiLCJmaWxlIjoiL2hvbWUvcnVubmVyL3dvcmsvcGFydG9vLXVpL3BhcnRvby11aS9wYWNrYWdlcy91aS9zcmMvY29tcG9uZW50cy9UYWJsZS9zdWJDb21wb25lbnRzL0hlYWRlci9IZWFkZXIuc3R5bGVkLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5leHBvcnQgY29uc3QgU3R5bGVkSGVhZGVyID0gc3R5bGVkKCd0aGVhZCcpYFxuICAgIHBhZGRpbmc6IDhweCAyNHB4O1xuICAgIGJhY2tncm91bmQtY29sb3I6ICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29sb3JzLnNlY29uZGFyeS5hbHBoYX07XG4gICAgYm9yZGVyLXRvcDogMXB4IHNvbGlkICR7KHsgdGhlbWUgfSkgPT4gdGhlbWUuY29sb3JzLmRlZmF1bHQuYWxwaGF9O1xuICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAkeyh7IHRoZW1lIH0pID0+IHRoZW1lLmNvbG9ycy5kZWZhdWx0LmFscGhhfTtcbmA7XG4iXX0= */"));
export {
  o as StyledHeader
};
